export const defaultSettings = {
  text: 'survey.button.submit.text',
  width: '220',
  height: '40',
  fontSize: '14',
  fontWeight: 'normal',
  borderRadius: '3',
  backgroundColor: '#444444',
  textColor: '#ffffff',
  align: 'center',
}
